import { render, staticRenderFns } from "./ProjectHeaderContent.vue?vue&type=template&id=2eda77a9"
import script from "./ProjectHeaderContent.vue?vue&type=script&lang=ts"
export * from "./ProjectHeaderContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports